var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.3675","y":"0.3675","width":"23.265","height":"23.265","rx":"11.6325","stroke":"black","strokeWidth":"0.735","key":0}),React.createElement("path",{"d":"M10.4647 18.2065H12.9155V11.9458H14.6272L14.8098 9.85017H12.9155V8.65516C12.9155 8.16157 13.0132 7.96674 13.4804 7.96674H14.8056V5.79321H13.1066C11.2887 5.79321 10.4647 6.61153 10.4647 8.17889V9.85017H9.19043V11.9717H10.4647V18.2022V18.2065Z","fill":"black","key":1})]);
}

Facebook.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
